import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconInfoMulticolorStyle0 = gravityIconIndividualCss;

const GravityIconInfoMulticolor = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'e92898756ff2f38741f880f45a4a65502e985f8c', color: this.color, size: this.size }, h("svg", { key: '528104125eb7c4c4d7bd116efec85a71fe8dd73c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'fb136f9e236f6bf50550e5e1d32383a76f0174d5', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9Z", fill: "currentColor", "fill-opacity": ".1" }), h("path", { key: '5951823fb01dd9632d146e2bfb567b1a632df340', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.25 8.56a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3 2.44v-.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-4h-2a.5.5 0 0 1-.5-.5Z", fill: "currentColor" }))));
    }
};
GravityIconInfoMulticolor.style = GravityIconInfoMulticolorStyle0;

export { GravityIconInfoMulticolor as gravity_icon_info_multicolor };

//# sourceMappingURL=gravity-icon-info-multicolor.entry.js.map